import {createAction} from '@reduxjs/toolkit';

const CLEAN_EVENT_INFO = 'CLEAN_EVENT_INFO';

export const cleanEventInfo = createAction(CLEAN_EVENT_INFO);
